import { useEffect } from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { seo } from '../data/seo'
import { site } from '../data/site'
import type { PageKey } from '../types/content'

export function useDocumentMeta(page: PageKey) {
  const { lang } = useLanguage()

  useEffect(() => {
    const meta = seo[page]
    document.title = meta.title[lang]
    upsertMeta('name', 'description', meta.description[lang])
    upsertMeta('property', 'og:title', meta.title[lang])
    upsertMeta('property', 'og:description', meta.description[lang])
    upsertMeta('property', 'og:locale', lang === 'en' ? 'en_US' : 'es_US')

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = `${site.website}${meta.path}`
  }, [page, lang])
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}
